import { render, staticRenderFns } from "./AllBatches.vue?vue&type=template&id=f016ea6a&"
import script from "./AllBatches.vue?vue&type=script&lang=js&"
export * from "./AllBatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports